import React from "react";
import { ModuleI } from "../types";

interface ModuleTopNavigationProps {
  module: ModuleI;
  onExploreClick: () => void;
}

const ModuleTopNavigation: React.FC<ModuleTopNavigationProps> = ({
  module,
  onExploreClick,
}) => {
  return (
    <div className="w-screen bg-white border-b border-gray-200 shadow-sm">
      <div className="w-full max-w-none px-4 py-3">
        <div className="flex items-center justify-center max-w-3xl mx-auto">
          {/* Breadcrumb Navigation */}
          <div className="flex items-center text-sm sm:text-base text-gray-700 flex-wrap gap-1 justify-center">
            <span
              className="cursor-pointer hover:text-electrum transition-colors underline"
              onClick={onExploreClick}
            >
              Explore
            </span>
            <span className="text-gray-400">›</span>
            <span className="text-gray-900 font-semibold underline">
              {module.title}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleTopNavigation;
